import React from 'react';
import PropTypes from 'prop-types';

const countLimit = 5;

export function ToastMessageTitle({ title }) {
  return <b className="preferred-suppliers-toast-message__title">{title}</b>;
}

ToastMessageTitle.propTypes = {
  title: PropTypes.string,
};

export function ToastMessageContentSuppliers({ suppliers = [], added, bold, noun = 'supplier' }) {
  const count = suppliers.length;
  const sliced = suppliers.slice(0, countLimit);

  return count ? (
    <div className="preferred-suppliers-toast-message__suppliers">
      {sliced.map(({ label }) => label).join(', ')} {sliced.length < suppliers.length ? 'and more ' : ''}
      {count > 1 ? 'have' : 'has'} been {added ? <>{bold ? <b>added</b> : 'added'} to</> : <>{bold ? <b>deleted</b> : 'deleted'} from</>}{' '}
      your {noun} preferences.
    </div>
  ) : null;
}

ToastMessageContentSuppliers.propTypes = {
  suppliers: PropTypes.array,
  added: PropTypes.bool,
  bold: PropTypes.bool,
  noun: PropTypes.string,
};
